import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ThumbsUpIcon } from 'lucide-react';
import { IMAGES, funnelSteps, retargetingAds } from '../data/funnel';
export function RetargetingPage() {
  const creatives: Record<string, string> = {
    'ad-1': IMAGES.cover,
    'ad-2': IMAGES.sarah,
    'ad-3': IMAGES.park
  };
  return <main className="w-full bg-cream pb-24" data-id="element-191" data-mp="zs1zzyizpbza">
      <div className="mx-auto max-w-6xl px-5 pt-12" data-id="element-192" data-mp="25mkh2a4ioed">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy/60 transition-colors duration-150 ease-out hover:text-navy-deep" data-id="element-193" data-mp="26xmoxnx7o3d">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-194" data-mp="c1zc7um3ys6h" />
          Volver al inicio del funnel
        </Link>

        <h1 className="mt-6 font-display text-[1.75rem] font-bold leading-tight text-navy-deep sm:text-[2.4rem]" data-id="element-195" data-mp="g67420nv4o8x">
          Secuencia de retargeting · $2 al día
        </h1>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-navy/70" data-id="element-196" data-mp="1rizv198tx8nx">
          Tres anuncios que cubren los 7 días posteriores a la visita. Cada uno ataca una objeción
          distinta y devuelve al usuario al punto exacto donde abandonó.
        </p>

        <section aria-label="Ruta del funnel" className="mt-8 flex flex-wrap items-center gap-2" data-id="element-197" data-mp="1wph3ctf918ti">
          {funnelSteps.slice(0, 5).map((s, i) => <React.Fragment key={s.path} data-id="element-198" data-mp="1snm37s9211hb" data-mpi={i}>
              <Link to={s.path} className="rounded-full border border-navy-deep/15 bg-paper px-3.5 py-1.5 text-xs font-semibold text-navy-deep transition-colors duration-150 ease-out hover:bg-gold-pale" data-id="element-199" data-mp="1np2ghpmmzlnw">
                {s.label}
              </Link>
              {i < 4 && <span className="text-navy/30" data-id="element-200" data-mp="190g33tgkl3zb">→</span>}
            </React.Fragment>)}
        </section>

        <div className="mt-9 grid gap-6 lg:grid-cols-3" data-id="element-201" data-mp="14z2y1llax4tg">
          {retargetingAds.map(ad => <article key={ad.id} className="flex h-full flex-col rounded-xl border border-navy-deep/10 bg-paper shadow-card" data-id="element-202" data-mp="zz84faa5614p">
              <div className="flex items-baseline justify-between gap-3 border-b border-navy-deep/10 px-5 py-3" data-id="element-203" data-mp="qe8gqqaxs5ng">
                <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-204" data-mp="gdy71fo41gd1">
                  {ad.window}
                </span>
                <span className="text-xs font-semibold text-navy/55" data-id="element-205" data-mp="ldb2got1rvr8">{ad.angle}</span>
              </div>

              <div className="p-5" data-id="element-206" data-mp="1935fb6dd9kbh">
                <div className="flex items-center gap-2.5" data-id="element-207" data-mp="1e1gm188d7eph">
                  <span className="grid h-8 w-8 place-items-center rounded-full bg-navy-deep font-display text-xs font-bold text-gold" data-id="element-208" data-mp="1e0nei51l0l6a">
                    FL
                  </span>
                  <div data-id="element-209" data-mp="14ac9ef65w5xt">
                    <p className="text-xs font-semibold text-navy-deep" data-id="element-210" data-mp="149kdf38nk670">Frenchie Longevity</p>
                    <p className="text-[11px] text-navy/45" data-id="element-211" data-mp="1rzwvh6xm3jbb">Publicidad</p>
                  </div>
                </div>

                <p className="mt-3 text-[0.9rem] leading-relaxed text-navy-deep/85" data-id="element-212" data-mp="1wtrdm5xkjq8a">
                  {ad.primaryText}
                </p>
              </div>

              <img src={creatives[ad.id]} alt={`Creativo del anuncio: ${ad.headline}`} className="aspect-square w-full object-cover" data-id="element-213" data-mp="3cih50o82dij8" />

              <div className="flex items-center justify-between gap-3 bg-cream px-5 py-3.5" data-id="element-214" data-mp="3mad2py68n6mx">
                <p className="min-w-0 font-display text-sm font-bold leading-snug text-navy-deep" data-id="element-215" data-mp="2ykaejt5g2ktl">
                  {ad.headline}
                </p>
                <span className="shrink-0 rounded-md bg-navy-deep px-3 py-1.5 text-xs font-semibold text-paper" data-id="element-216" data-mp="37k5tm924ezyw">
                  {ad.cta}
                </span>
              </div>

              <dl className="mt-auto space-y-2 border-t border-navy-deep/10 px-5 py-4 text-xs" data-id="element-217" data-mp="32n73e1lkvd5z">
                <div data-id="element-218" data-mp="mw1a3nvk3154">
                  <dt className="font-semibold uppercase tracking-[0.12em] text-navy/45" data-id="element-219" data-mp="huvf1jefb1sf">
                    Audiencia
                  </dt>
                  <dd className="mt-0.5 text-navy/70" data-id="element-220" data-mp="1d6bqy1fypjvo">{ad.audience}</dd>
                </div>
                <div data-id="element-221" data-mp="1i567ewqgiwcm">
                  <dt className="font-semibold uppercase tracking-[0.12em] text-navy/45" data-id="element-222" data-mp="1i4dasol7pn87">
                    Creativo
                  </dt>
                  <dd className="mt-0.5 text-navy/70" data-id="element-223" data-mp="1s217hk2dp4t0">{ad.creativeNote}</dd>
                </div>
              </dl>
            </article>)}
        </div>

        <p className="mt-8 flex items-start gap-2 text-sm leading-relaxed text-navy/60" data-id="element-224" data-mp="1w3mg2t7vqwxe">
          <ThumbsUpIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/40" data-id="element-225" data-mp="211ee84z4bfa1" />
          Reparto sugerido: $10/día al tráfico frío hacia la Bridge Page y $2/día repartidos entre
          estos tres anuncios, con exclusión de compradores en las tres audiencias.
        </p>
      </div>
    </main>;
}